<template>
  <div id="app" :data-id="$route.params.brand" :lang="$i18n.locale">
    <transition name="fade">
      <router-view></router-view>
    </transition>
  </div>
</template>

<script>
import Fingerprint2 from 'fingerprintjs2';
import Cookies from 'js-cookie';
import Axios from '@/helpers/axios';

require('bootstrap/scss/bootstrap.scss');

export default {
  name: 'app',
  data() {
    return {
      viewTransition: '',
    };
  },
  created() {
    this.$moment.locale(this.$i18n.locale);

    new Fingerprint2().get((result) => {
      const data = {
        lang: this.$i18n.locale,
        brand_id: this.$route.params.brand,
        phone_type: this.$store.state.client.phoneType,
        p: this.$store.state.client.phoneType,
        os: this.$store.state.client.os,
        device_name: this.$store.state.client.deviceName,
        dtk: this.$store.state.client.dtk,
        fingerprint: result,
      };

      Axios({
        method: 'post',
        url: '/Login_w/registerDevice',
        data: Object.assign(data, this.$route.query),
      })
        .then((response) => {
          if (response.data.code === 500) {
            this.$store.commit('setDtk', response.data.data.dtk);
          }
        });
    });
  },
  watch: {
    $route() {
      const supportedLanguages = ['en', 'vi', 'th'];
      if (!Cookies.get('lang')) {
        const queryLang = this.$route.query.lang;
        if (typeof queryLang === 'string') {
          const matchedLang = supportedLanguages.find(lang => queryLang.includes(lang));

          if (matchedLang) {
            this.$i18n.locale = matchedLang;
          }
        }
      }
    },
  },
};
</script>

<style lang="sass">
$cb: cubic-bezier(.4, 0, .2, 1)

@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&family=Noto+Sans+TC:wght@100..900&display=swap')
@import url('https://fonts.googleapis.com/icon?family=Material+Icons')

html,
body,
#app
  width: 100%
  height: 100%

  font-family: Montserrat, 'SF Pro TC', 'SF Pro HK', 'SF Pro SC', 'SF Pro Text', 'PingFang TC', 'PingFang HK', 'PingFang SC', 'Noto Sans TC', ui-sans-serif, system-ui, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'
  font-size: 1rem
  color: #37474F
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale

  &[lang="vi"]
    font-size: 14px

.monospace
  font-family: 'Space Mono', monospace
  font-weight: normal

@keyframes placeHolderShimmer
  0%
    background-position: 100% 0

  100%
    background-position: -100% 0

a,
.btn-link
  &:hover
    text-decoration: none !important

  &:active
    text-decoration: none !important

.narrow-gutters
  margin-right: -5px !important
  margin-left: -5px !important

  & > .col,
  & > [class*="col-"]
    padding-right: 5px !important
    padding-left: 5px !important

.el-message
  top: 75% !important
  max-width: 80%
  min-width: auto
  padding: 12px 15px
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, .14), 0 3px 1px -2px rgba(0, 0, 0, .2), 0 1px 5px 0 rgba(0, 0, 0, .12)

  border-color: transparent
  border-radius: 10px

  &--success
    background-color: white

    font-weight: bold

    .el-message__content
      color: inherit

  &--error
    background-color: #FD0000

    .el-message__content
      color: white

  .el-message__content
    font-weight: bold

  .el-message__icon
    display: none

.push-leave-active,
.push-enter-active
  z-index: 999
  transition: all 5s cubic-bezier(.4, 0, .2, 1)

.push-enter
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 999

  transform: translateY(100%)

.push-enter-to
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  z-index: 999

  transform: translateY(0%)

.push-leave,
.push-leave-to
  position: absolute
</style>

<style lang="sass">
$cb: cubic-bezier(.4, 0, .2, 1)

@keyframes showSweetAlert
  0%
    opacity: 0
    transform: scale(.75)

  100%
    opacity: 1
    transform: scale(1)
// Sweetalert2

body
  &.swal2-shown.swal2-height-auto
    height: 100% !important

.swal2
  &-container
    padding: 16px !important

    &.swal2-shown
      background-color: rgba(28, 28, 28, .75) !important

  &-popup
    padding: 0 !important

    border-radius: 16px !important

    background-color: #111 !important

    color: white !important

    &.swal2-show
      animation: showSweetAlert .25s $cb !important

    .swal2-header
      display: none !important

    .swal2-html-container
      margin: 0 !important
      padding: 32px 24px 16px !important

      font-size: 1rem !important
      font-weight: bold !important
      color: white !important
      text-align: left !important

    .swal2-input
      margin: 16px 24px 0 !important
      box-shadow: none !important

      background-color: #333 !important

      border-radius: 16px !important
      border-color: transparent !important

      font-size: 1.5rem !important
      text-align: center !important
      color: white

      &:focus
        border-color: transparent !important

        background-color: #444 !important

      &[type=number]
        max-width: auto !important

    .swal2-actions
      justify-content: flex-end !important
      padding: 8px 8px 8px 24px !important
      margin: 0 !important

    .swal2-styled
      &.swal2-confirm,
      &.swal2-cancel,
      &.swal2-deny
        margin: 0 !important
        padding: 16px !important

        border-radius: 0 !important

        background: none !important

        font-size: 0.875rem !important
        font-weight: 700 !important
        color: #ffea00 !important

        outline: none !important
        appearance: none !important

        &:focus
          box-shadow: none !important

        &:hover,
        &:active
          color: #ffea00 !important

          outline: none !important
          transform: scale(.95) !important

      &.swal2-cancel
        color: #656565 !important

.animation-slide-in-bottom-enter-active,
.animation-slide-in-bottom-leave-active
  transition: opacity .25s cubic-bezier(.4, 0, .2, 1), transform .15s cubic-bezier(.4, 0, .2, 1)

.animation-slide-in-bottom-enter,
.animation-slide-in-bottom-leave-to
  opacity: 0
  transform: translateY(100%)
</style>
